//// ~~~~~~~~~~~~~~~~~~~~~~~~~ START: METHODS TO SIMULATE ASYNC API CALLS ~~~~~~~~~~~~~~~~~~~~~~~~~ ////
//axios
import axios from 'axios';
import { url } from 'utils/urls';

const withCredentials = true;
const headers = { 'Accept': 'application/json', 'Content-Type': 'multipart/form-data' };

// General Info
export const asyncGetGeneralInfo = accountUUID => axios.get(`${url.ppa.accounts}/${accountUUID}`, { withCredentials });
export const asyncUpdateGeneralInfo = (data, formName, accountUUID) => axios.put(`${url.ppa.accounts}/${accountUUID}`, data, { withCredentials });

// Edit User Info
export const asyncGetUsers = accountUUID => axios.get(`${url.ppa.accounts}/${accountUUID}/users/permissions`, { withCredentials });
export const asyncEditUserInfo = (data, formName, userUUID) => axios.put(`${url.ppa.users}/${userUUID}/permissions`, data, { withCredentials });
export const asyncDeleteUser = userUUID => axios.delete(`${url.ppa.users}/${userUUID}`, { withCredentials });
// Add User
export const asyncAddUser = (data, formName, accountUUID)  => axios.post(`${url.ppa.accounts}/${accountUUID}/users/permissions`, data, { withCredentials });
// Send Invite
export const asyncInviteUser = userUUID => axios.put(`${url.ppa.users}/${userUUID}/invite`, {}, { withCredentials });
// Resend Invite
export const asyncResendInvite = (userUUID, isResend) => axios.post(`${url.ppa.auth.resend}/user-invite`, {userUUID, isResend} , { withCredentials });

// Payment Information
export const asyncGetPaymentInformation = (accountUUID) => axios.get(`${url.ppa.accounts}/${accountUUID}/paymentinfo`, { withCredentials });
export const asyncGetCheckInformation = (paymentUUID) => axios.get(`${url.ppa.paymentInfo}/check/${paymentUUID}`, { withCredentials });
export const asyncGetACHInformation = (paymentUUID) => axios.get(`${url.ppa.paymentInfo}/ach/${paymentUUID}`, { withCredentials });
export const asyncGetPayPalInformation = (paymentUUID) => axios.get(`${url.ppa.paymentInfo}/paypal/${paymentUUID}`, { withCredentials });
export const asyncGetWireTransferInformation = (paymentUUID) => axios.get(`${url.ppa.paymentInfo}/wire/${paymentUUID}`, { withCredentials });

// Async payment information put requests
export const asyncSavePaymentInformation = (data, paymentType, accountUUID) => {
    let callURL;
    switch (paymentType) {
        case `PAYPAL`:
            callURL = `${url.ppa.accounts}/${accountUUID}/paymentinfo/paypal`;
            break;
        case `ACH`:
            callURL = `${url.ppa.accounts}/${accountUUID}/paymentinfo/ach`;
            break;
        case `CHECKS`:
            callURL = `${url.ppa.accounts}/${accountUUID}/paymentinfo/check`;
            break;
        case `WIRE`:
            callURL = `${url.ppa.accounts}/${accountUUID}/paymentinfo/wire`;
            break;
        default :
            break;
    }
    return axios.post(callURL, data, { withCredentials });
};

export const asyncUpdatePaymentInformation = (data, paymentType, paymentUUID) => {
    let callURL;
    let config = paymentType === 'PAYPAL' ? { withCredentials } : { headers, withCredentials };
    switch (paymentType) {
        case `PAYPAL`:
            callURL = `${url.ppa.paymentInfo}/paypal/${paymentUUID}`;
            break;
        case `ACH`:
            callURL = `${url.ppa.paymentInfo}/ach/${paymentUUID}`;
            break;
        case `CHECKS`:
            callURL = `${url.ppa.paymentInfo}/check/${paymentUUID}`;
            break;
        case `WIRE`:
            callURL = `${url.ppa.paymentInfo}/wire/${paymentUUID}`;
            break;
        default :
            break;
    }
    return axios.put(callURL, data, config);
};

// Async ADSTXT get requests
export const asyncGetAdsTxt = (accountUUID, siteUUID) => axios.get(`${url.ppa.sites}/${siteUUID}/adstxt?accountUUID=${accountUUID}`, { withCredentials });
export const asyncVerifyAdsTxt = (siteUUID) => axios.put(`${url.ppa.sites}/${siteUUID}/adstxt/verify`, {}, { withCredentials });

// Account Data
export const getAllSitesCall = accountUUID => axios.get(`${url.ppa.accounts}/${accountUUID}/sites?filterRonSites=false`, { withCredentials });

